import {Goal, Ecommerce} from './Goal';
const s3 = window.s3 = window.s3 || {};
s3.Ecommerce = Ecommerce;
s3.Goal = Goal;


// WEBPACK FOOTER //
// ./index.js